import React from 'react';
import classnames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface INewFeatureTipsContentProps extends IBaseProps {
  description?: string | React.ReactElement | null;
  onClose?: () => void;
}

const NewFeatureTipsContent: React.FC<INewFeatureTipsContentProps> = (props) => {
  const { style, className, description, onClose } = props;

  return (
    <div style={style} className={classnames('dbg-new-feature-tips-content', className)}>
      {React.isValidElement(description) && <div className="dbg-new-feature-tips-content__text">{description}</div>}
      {typeof description === 'string' && (
        <div className="dbg-new-feature-tips-content__text" dangerouslySetInnerHTML={{ __html: description }} />
      )}
      <SvgIcon
        className="dbg-new-feature-tips-content__close-icon"
        type="clonse"
        onClick={(e?: React.SyntheticEvent) => {
          e?.stopPropagation();
          onClose?.();
        }}
      />
    </div>
  );
};

export default NewFeatureTipsContent;
